import { useTranslation } from 'react-i18next';

export const useInventoryStatusesData = () => {
    const { t } = useTranslation();

    const inventoryStatusesData = [
        {
            status: 0,
            text: t('inventory.status.text.inWork'),
            color: '#C4CCD7',
        },
        {
            status: 1,
            text: t('inventory.status.text.free'),
            color: '#2AB96B',
        },
        {
            status: 2,
            text: t('inventory.status.text.broken'),
            color: '#EC0818',
        },
        {
            status: 3,
            text: t('inventory.status.text.decommissioned'),
            color: '#8A0000',
        },
    ];

    return { inventoryStatusesData };
};
